<h1 style="display: flex; justify-content: center">FFK - {{'Dashboard'| translate}}</h1>

<div class="dashboard-container">
  <div class="card-row">
    <mat-card class="dashboard-card">
      <mat-card-header>
        <mat-card-title>{{ 'News Categories' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'This card has the news categories.' | translate }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button [routerLink]="['/admin-panel/admin-news-categories']" color="primary"
                mat-raised-button>{{ 'View News Category' | translate }}</button>
      </mat-card-actions>
    </mat-card>

    <mat-card class="dashboard-card">
      <mat-card-header>
        <mat-card-title>{{ 'News' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'This card has the news data.' | translate }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button [routerLink]="['/admin-panel/admin-news']" color="primary"
                mat-raised-button>{{ 'View News' | translate }}</button>
      </mat-card-actions>
    </mat-card>

    <mat-card class="dashboard-card">
      <mat-card-header>
        <mat-card-title>{{ 'League' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'This card has the leagues of federation football of Kosova.' | translate }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button [routerLink]="['/admin-panel/admin-league']" color="primary"
                mat-raised-button>{{ 'View Leagues' | translate }}</button>
      </mat-card-actions>
    </mat-card>

    <mat-card class="dashboard-card">
      <mat-card-header>
        <mat-card-title>{{ 'Teams' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'This card has the teams of each selected League.' | translate }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button [routerLink]="['/admin-panel/admin-teams']" color="primary"
                mat-raised-button>{{ 'View Teams' | translate }}</button>
      </mat-card-actions>
    </mat-card>

    <mat-card class="dashboard-card">
      <mat-card-header>
        <mat-card-title>{{ 'Standings' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'This card has the standings of the teams for each league.' | translate }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button [routerLink]="['/admin-panel/admin-standings']" color="primary"
                mat-raised-button>{{ 'View Standings' | translate }}</button>
      </mat-card-actions>
    </mat-card>

    <mat-card class="dashboard-card">
      <mat-card-header>
        <mat-card-title>{{ 'National Games' | translate }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ 'This card has the matches between national teams.' | translate }}</p>
      </mat-card-content>
      <mat-card-actions>
        <button [routerLink]="['/admin-panel/admin-national-games']" color="primary"
                mat-raised-button>{{ 'View National Games' | translate }}</button>
      </mat-card-actions>
    </mat-card>

  </div>
</div>
